import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import Dialog from 'quasar/src/plugins/Dialog.js';;
import quasarUserOptions from "./quasar-user-options";
import axios from "axios";

let myApp = createApp(App);

myApp
  .use(Quasar, {
    plugins: {
      Notify,
      Loading,
      Dialog,
    },
    config: {
      loading: {},
    },
    quasarUserOptions,
  })
  .use(store)
  .use(router);

// provide
myApp.provide(
  "$http",
  axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
  })
);

myApp.provide("rupiah", (number) => {
  let temp = Intl.NumberFormat("id", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(number);

  return temp;
});

myApp.provide("thousand", (number) => {
  return Intl.NumberFormat("id").format(number);
});
// end of provide

myApp.mount("#app");
